/* eslint-disable no-useless-escape */
import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FallingLines } from 'react-loader-spinner';
import {
  LOGIN_TITLE,
  ENTER,
  NO_ACCOUNT,
  START_REG,
  INCORRECT_EMAIL_FORMAT,
  BAD_CREDENTIALS,
} from '../../../Utils/Constants/GlobalConstants';
import {
  changeUserAuthStatus,
  changeUserFirstLetter,
} from '../../../DataStore/actions/searchFormActions';

const mapStateToProps = (state) => ({ ...state });

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emailValue: '',
      passwordValue: '',
      errorMessage: '',
      emailWasFocused: false,
      isEmailValid: false,
      isPasswordValid: false,
      isLoginInProgress: false,
    };
  }

  handlePasswordChange = (e) => {
    const password = e.target.value;
    this.setState({ passwordValue: password }, () => {
      this.passwordValidator();
    });
  };

  handleEmailChange = (e) => {
    const { emailWasFocused } = this.state;
    const emailValue = e.target.value;
    this.setState({ emailValue });

    if (emailWasFocused) {
      if (this.emailValidation()) {
        this.setState({ isEmailValid: true });
      } else {
        this.setState({ isEmailValid: false });
      }
    }
  };

  passwordValidator = () => {
    const { passwordValue } = this.state;
    if (passwordValue.length >= 1) {
      this.setState({ isPasswordValid: true });
    } else {
      this.setState({ isPasswordValid: false });
    }
  };

  emailValidation = () => {
    const { emailValue } = this.state;
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!emailValue || regex.test(emailValue) === false) {
      this.setState({ errorMessage: INCORRECT_EMAIL_FORMAT });
      return false;
    }

    this.setState({ errorMessage: '' });
    return true;
  };

  handleEmailInputBlur = () => {
    const { emailValue } = this.state;
    if (emailValue.length > 0) {
      if (this.emailValidation()) {
        this.setState({ isEmailValid: true });
      } else {
        this.setState({ isEmailValid: false });
      }
      this.setState({ emailWasFocused: true });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ isLoginInProgress: true });

    const { passwordValue, emailValue } = this.state;
    const {
      closeModal,
      changeUserAuthStatus: changeUserAuthStatusAction,
      changeUserFirstLetter: changeUserFirstLetterAction,
      location,
    } = this.props;

    axios
      .post('/api/auth/signin', {
        email: emailValue,
        password: passwordValue,
      })
      .then((response) => {
        const { email } = response.data;
        window.localStorage.setItem('accessToken', response.data.accessToken);
        window.localStorage.setItem('email', email);
        window.localStorage.setItem('isUserLoggedIn', true);

        if (email) {
          changeUserFirstLetterAction(email.charAt(0).toUpperCase());
        }

        changeUserAuthStatusAction(true);
        closeModal();

        if (location.pathname === '/profile') {
          window.location.reload();
        }
      })
      .catch((error) => {
        if (error.response) {
          this.setState({ errorMessage: BAD_CREDENTIALS });
        }
      })
      .finally(() => {
        this.setState({ isLoginInProgress: false });
      });
  };

  render() {
    const {
      emailValue,
      passwordValue,
      isEmailValid,
      emailWasFocused,
      isPasswordValid,
      errorMessage,
      isLoginInProgress,
    } = this.state;

    const { showRegForm } = this.props;

    return (
      <div className="login_form_w">
        <div className="bm_text_24 login_title">{LOGIN_TITLE}</div>
        <input
          value={emailValue}
          className={`login_form_input ${
            !isEmailValid && emailWasFocused ? 'logon_ivalid_input' : ''
          }`}
          onChange={this.handleEmailChange}
          placeholder="Email"
          onBlur={this.handleEmailInputBlur}
        />
        <input
          value={passwordValue}
          className={`login_form_input ${isEmailValid ? '' : ''}`}
          onChange={this.handlePasswordChange}
          placeholder="Пароль"
          type="password"
        />

        <div className="login_button_w">
          <button
            type="submit"
            className={`login_button ${
              isPasswordValid && isEmailValid
                ? 'blue_button login_btn_active'
                : 'login_btn_dis'
            }`}
            disabled={!isPasswordValid && !isEmailValid}
            onClick={this.handleSubmit}
          >
            <div className="login_button_content">
              {ENTER}
              <div className="login-falling-loading">
                <FallingLines
                  color="#ffffff"
                  width="30"
                  visible={isLoginInProgress}
                />
              </div>
            </div>
          </button>
          <div className="login_form_message rr_text_14">{errorMessage}</div>
        </div>

        <div className="login_show_reg">
          <span className="gr_text_16">
            {NO_ACCOUNT}
            &nbsp;
          </span>
          <button
            type="submit"
            className="blue_link login_register"
            onClick={showRegForm}
          >
            {START_REG}
          </button>
        </div>
      </div>
    );
  }
}

LoginForm.propTypes = {
  showRegForm: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  changeUserAuthStatus: PropTypes.func.isRequired,
  changeUserFirstLetter: PropTypes.func.isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
};

export default connect(mapStateToProps, {
  changeUserAuthStatus,
  changeUserFirstLetter,
})(LoginForm);
